import {
  createStyles,
  LoadingOverlay,
  Modal as MantineModal,
  type ModalProps as MantineModalProps
} from '@mantine/core'
import { type FC } from 'react'

const useStyles = createStyles((theme) => ({
  body: {
    position: 'relative'
  },
  header: {
    paddingBottom: theme.spacing.lg
  },
  title: {
    fontWeight: 600
  }
}))

export interface ModalProps extends MantineModalProps {
  isLoading?: boolean
}

export const Modal: FC<ModalProps> = ({ children, classNames, isLoading = false, ...props }) => {
  const { classes } = useStyles()

  return (
    <MantineModal
      classNames={{
        body: classes.body,
        header: classes.header,
        title: classes.title,
        ...classNames
      }}
      keepMounted={false}
      {...props}
    >
      <LoadingOverlay visible={isLoading} />
      {children}
    </MantineModal>
  )
}
